// extracted by mini-css-extract-plugin
module.exports = {"tabs-labels":"about-marketplace-desktop_tabs-labels__5Co5u","tab":"about-marketplace-desktop_tab__2URkp","label":"about-marketplace-desktop_label__19-3L"};